import React from 'react'

import { getPublicUrl } from '../../utils/env/env'
import { useEnv } from '../../utils/contexts/EnvContext'
import Image from '../presentation/Image'

const Logo = ({ white, noText, width, onClick }) => {
  const env = useEnv()
  let imgName = 'btime-logo-roxo.png'
  if (white) {
    imgName = 'btime-logo.png'
    if (noText) imgName = 'btime-logo-square-white.png'
  }
  return <Image onClick={onClick} width={width || '6rem'} src={getPublicUrl(env, imgName)} />
}

export default Logo
